import { useAvatar } from "@/contexts/AvatarContext";
import { User } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Skeleton } from "@/components/ui/skeleton";
import { useLocalizations } from "@/hooks/useLocalizations";

interface UserAvatarProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

export function UserAvatar({ size = "md", className = "" }: UserAvatarProps) {
  const { avatarUrl, displayName, loading } = useAvatar();
  const { lCommon } = useLocalizations();

  const sizeClasses = {
    sm: "h-8 w-8 text-xs",
    md: "h-10 w-10 text-sm",
    lg: "h-16 w-16 text-lg",
  };

  if (loading) {
    return <Skeleton className={`${sizeClasses[size]} rounded-full ${className}`} />;
  }

  return (
    <Avatar className={`${sizeClasses[size]} ${className}`}>
      <AvatarImage src={avatarUrl} alt={displayName || lCommon('labels.user', { defaultValue: 'User' })} />
      <AvatarFallback className="bg-primary/10 text-primary">
        <User className="h-4 w-4" />
      </AvatarFallback>
    </Avatar>
  );
}
